// import {
// 	XMarkIcon,
// } from '@heroicons/react/24/outline'

// import {
// 	Squares2X2Icon,
// } from '@heroicons/react/24/outline'

import { string } from 'yup';


const obj =  {
	field:[
		
        { 
			title: "A piece of content", 
			attr: "content",  
			value: "", 
			id:"content",
			placeholder: "A piece of content (article, blog post, etc.)", 
			label: "Place some code above to understand how it works",
			type: "code",
			maxLength: 2000,
			yup: string().nullable().trim("Initially whitespace are not allowed").required("A piece of content is Required"),

			// max: 100,
			min: 3,
			required: true,
			error: "",
			type: "textarea",
			example: `function HelloWorld(text){ 
	let text || "Hello World"; 
	console.log(text);
	}`,
		},
	],
    example:[
	
        { 
			title: "A piece of content", 
			attr: "content",  
			value: "Meeting", 
			id:"content",
			placeholder: "A piece of content (article, blog post, etc.)", 
			label: "Place some code above to understand how it works",
			type: "code",
			maxLength: 2000,
			yup: string().nullable().trim("Initially whitespace are not allowed").required("A piece of content is Required"),

			// max: 100,
			min: 3,
			required: true,
			error: "",
			type: "textarea",
			example: `function HelloWorld(text){ 
	let text || "Hello World"; 
	console.log(text);
	}`,
		},
	],

	editor:{
		output:`This meeting was held to discuss the progress of the project. The team discussed their current tasks and identified areas for improvement. They also discussed ideas for new features and how to implement them. At the end of the meeting, everyone agreed on a timeline for completing the project. The team is confident that they can meet their goals and complete the project on time.
        \nThis meeting focused on discussing progress made towards a project, identifying areas needing improvement, brainstorming ideas for new features, and agreeing upon a timeline to complete it all. Everyone involved is optimistic that they can meet their goals and finish within the set timeframe.`
	}
	}
	
	
	export default obj
	
	